import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=7ea73558"
import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea73558')) {
      api.createRecord('7ea73558', component.options)
    } else {
      api.reload('7ea73558', component.options)
    }
    module.hot.accept("./CheckoutPage.vue?vue&type=template&id=7ea73558", function () {
      api.rerender('7ea73558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/client/checkout/CheckoutPage.vue"
export default component.exports